import { formatDisplayShort } from '../../../lib/dateUtils';
import Card from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';

/**
 * Test history tab panel for the site details page.
 * All data comes from the parent via props.
 *
 * canDeleteSessions — admin-only; shows a Delete action per completed session.
 * onDeleteSession    — (sessionId) => void
 * isDeletingSession  — disables the Delete buttons while a delete is in flight
 */
export default function SiteDetailsHistoryPanel({
  siteSessions,
  sessionsLoading,
  canDeleteSessions = false,
  onDeleteSession,
  isDeletingSession = false,
}) {
  const handleDelete = (session) => {
    const when = session.end_time
      ? formatDisplayShort(session.end_time)
      : (session.start_time ? formatDisplayShort(session.start_time) : 'this session');
    if (window.confirm(
      `Delete the completed session from ${when}? This permanently removes its recorded tests and cannot be undone.`
    )) {
      onDeleteSession?.(session.id);
    }
  };

  return (
    <Card>
      {sessionsLoading ? (
        <p className="text-muted">Loading sessions…</p>
      ) : siteSessions.length === 0 ? (
        <p className="text-muted">No completed sessions for this site.</p>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Technician</th>
                <th>Tested</th>
                {canDeleteSessions && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {siteSessions.map((s) => (
                <tr key={s.id}>
                  <td>{s.end_time ? formatDisplayShort(s.end_time) : (s.start_time ? formatDisplayShort(s.start_time) : '—')}</td>
                  <td>{s.session_type === 'repair' ? 'Repair' : 'Inspection'}</td>
                  <td>{s.user_name || '—'}</td>
                  <td>{s.total_assets ?? 0}</td>
                  {canDeleteSessions && (
                    <td>
                      <Button
                        type="button"
                        variant="danger"
                        size="sm"
                        disabled={isDeletingSession}
                        onClick={() => handleDelete(s)}
                        aria-label="Delete session"
                      >
                        Delete
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
